import Box from 'component/layoutComponents/Box';
import AutoLinksModule from 'quill-auto-links';
import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import { StyledLabel, StyledReactQuill } from './RichEditor.style';
import { StyledAsterisk } from '../Textbox/Textbox.style';

export interface IRichEditorProps {
  value: string;
  onChange?: (html: string) => void;
  label?: string;
  boldLabel?: boolean;
  fontSize?: string;
  placeholder?: string;
  required?: boolean;
}

const AutoLinks = (AutoLinksModule as any).default || AutoLinksModule;
Quill.register('modules/autoLinks', AutoLinks);

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
];

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['blockquote', 'link'],
    ['clean'],
  ],
  autoLinks: true,
};

const RichEditor = (props: IRichEditorProps) => {
  const { value, onChange, label, boldLabel, fontSize, placeholder, required } = props;

  return (
    <Box>
      {label && (
        <StyledLabel className="title" bold={boldLabel} fontSize={fontSize}>
          {label}
          {required && <StyledAsterisk>*</StyledAsterisk>}
        </StyledLabel>
      )}
      <StyledReactQuill>
        <ReactQuill
          tabIndex={0}
          theme="snow"
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          id="txt-richeditor-input"
        />
      </StyledReactQuill>
    </Box>
  );
};

export default RichEditor;
